// Model.js
// -----------------------
// @module Case
define("Ames.RotateImages.RotateImages.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/RotateImages/SuiteScript2/RotateImages.Service.ss"
            ),
            true
        )
});
});
